<div class="background-modal"></div>
<div class="window-info-modal">
  <div class="header-row">
    <span>{{ 'navigation.projectInfo' | translate }}</span>
    <ops-project-status
      [isPreview]="false"
      [userRole]="userRole"
      [selectedStatus]="info.status"
      (statusChanged)="onProjectStatusChange($event)"
    ></ops-project-status>
  </div>
  <div class="field">
    <div class="label">
      {{ 'projectEstimate.projectInfo.client' | translate }}
    </div>
    <input [(ngModel)]="clientName" focusSelect />
  </div>
  <div class="field">
    <label
      class="label different-billing-company"
      for="different-billing-company"
    >
      <input
        [checked]="useDifferentBillingCompany"
        (click)="toggleDifferentBillingCompany()"
        id="different-billing-company"
        type="checkbox"
      />
      {{ 'projectEstimate.projectInfo.billingCompany' | translate }}
    </label>
    <input
      [disabled]="!hasDifferentBillingCompany"
      [(ngModel)]="billingCompany"
      focusSelect
    />
  </div>
  <div class="field">
    <div class="label">
      {{ 'projectEstimate.projectInfo.projectName' | translate }}
    </div>
    <input [(ngModel)]="info.name" focusSelect />
  </div>
  <div class="field">
    <div class="label">
      {{ 'projectEstimate.projectInfo.projectCode' | translate }}
    </div>
    <input [(ngModel)]="info.code" focusSelect />
  </div>
  <div class="button-row">
    <div class="cancel-btn" (click)="close(true)">
      {{ 'auth.settings.cancel' | translate }}
    </div>
    <div class="save-btn" (click)="onSave()">
      {{ 'auth.settings.save' | translate }}
    </div>
  </div>
</div>
